import { googlePartners, privacyAndCookiePolicy } from 'mk2/apps/about/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'about',
    exact: true,
    path: privacyAndCookiePolicy,
    getPage: () => {
        return import('mk2/apps/about/containers/PrivacyAndCookiePolicy/PrivacyAndCookiePolicyPage' /* webpackChunkName: "about.PrivacyAndCookiePolicy" */);
    },
    modules: [ 'mk2/apps/about/containers/PrivacyAndCookiePolicy/PrivacyAndCookiePolicyPage' ],
}, {
    app: 'about',
    exact: true,
    path: googlePartners,
    getPage: () => {
        return import('mk2/apps/about/containers/GooglePartners/GooglePartnersPage' /* webpackChunkName: "about.GooglePartners" */);
    },
    modules: [ 'mk2/apps/about/containers/GooglePartners/GooglePartnersPage' ],
}];
